<template>
  <div class="lesson-entity-target-form">
    <component ref="targetForm" :is="entityform" v-if="entity_type"></component>
  </div>
</template>

<script>
import exerciseForm from '@/components/exercise/ExerciseForm'
import grammarForm from '@/components/grammar/GrammarForm'
import wordForm from '@/components/word/WordForm'
import kewenForm from '@/components/kewen/KewenForm'
import sentenceForm from '@/views/sentence/SentenceForm'
import ai_form from "@/components/lesson/units/ai/ai_form.vue";

export default {
  name: 'LessonTargetForm',
  components: {
    exerciseForm,
    grammarForm,
    wordForm,
    iq_wordForm: wordForm,
    kewenForm,
    sentenceForm,
    iq_sentenceForm: sentenceForm,
    ai_form
  },
  data() {
    return {
      entity_type: null,
      entity_id: 0,
    }
  },
  computed: {
    entityform() {
      if (/^ai_/.test(this.entity_type)) {
        return 'ai_form';
      } else if(/^industry_/.test(this.entity_type)) {
        return this.entity_type.substring(9) + 'Form';
      }
      return this.entity_type + 'Form'
    }
  },
  methods: {
    reset(model) {
      this.entity_type = model.entity_type
      this.entity_id = model.entity_id
      this.fetchData(model)
    },
    fetchData(model) {
      if (this.entity_type === 'kewen' || this.entity_type === 'industry_kewen') {
        this.$nextTick(() => {
          this.$refs.targetForm.reset(this.entity_id)
        })
        return
      } else if (/^ai_/.test(this.entity_type)) {
        this.$nextTick(() => {
          this.$refs.targetForm.reset(model)
        })
        return
      }
      const apiMap = {
        iq_word: 'api/word/form-model',
        industry_word: 'api/word/form-model',
        iq_sentence: 'api/sentence/form-model',
      };
      this.$http.get(apiMap[this.entity_type] || `api/${this.entity_type}/form-model`, {
        params: {
          id: this.entity_id
        }
      }).then(res => {
        this.$refs.targetForm.reset(res.data)
      })
    },
    submit() {
      return this.$refs.targetForm.submit()
    }
  }
}
</script>